import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/bg/media-monitoring")({
  component: () => <Outlet />,
});
